import { makeRootStyles } from "../../../theme/styles";

const useStyles = makeRootStyles(
  {
    imageContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "150px",
      width: "150px",
      position: "relative",
      "@media screen and (max-width: 768px)": {
        height: "96px",
        width: "96px",
      },
    },
    img: {
      width: "100%",
      height: "100%",
    },
  },
  { name: "N0ItemImage" },
);

export { useStyles };
